import { lazy } from 'react';
var REL00000 = lazy(function () { return import('view/Project/REL/REL00000'); });
var REL00001 = lazy(function () { return import('view/Project/REL/REL00001'); });
var REL00002 = lazy(function () { return import('view/Project/REL/REL00002'); });
var REL00003 = lazy(function () { return import('view/Project/REL/REL00003'); });
var REL00004 = lazy(function () { return import('view/Project/REL/REL00004'); });
var REL00005 = lazy(function () { return import('view/Project/REL/REL00005'); });
var REL00006 = lazy(function () { return import('view/Project/REL/REL00006'); });
var REL00007 = lazy(function () { return import('view/Project/REL/REL00007'); });
var REL00008 = lazy(function () { return import('view/Project/REL/REL00008'); });
var REL00009 = lazy(function () { return import('view/Project/REL/REL00009'); });
var REL00010 = lazy(function () { return import('view/Project/REL/REL00010'); });
var REL00011 = lazy(function () { return import('view/Project/REL/REL00011'); });
var REL00014 = lazy(function () { return import('view/Project/REL/REL00014'); });
var REL00015 = lazy(function () { return import('view/Project/REL/REL00015'); });
var REL00016 = lazy(function () { return import('view/Project/REL/REL00016'); });
var REL_ROUTES = [
    { path: '/REL00/REL00000', component: REL00000 },
    { path: '/REL00/REL00001', component: REL00001 },
    { path: '/REL00/REL00002', component: REL00002 },
    { path: '/REL00/REL00003', component: REL00003 },
    { path: '/REL00/REL00004', component: REL00004 },
    { path: '/REL00/REL00005', component: REL00005 },
    { path: '/REL00/REL00006', component: REL00006 },
    { path: '/REL00/REL00007', component: REL00007 },
    { path: '/REL00/REL00008', component: REL00008 },
    { path: '/REL00/REL00009', component: REL00009 },
    { path: '/REL00/REL00010', component: REL00010 },
    { path: '/REL00/REL00011', component: REL00011 },
    { path: '/REL00/REL00014', component: REL00014 },
    { path: '/REL00/REL00015', component: REL00015 },
    { path: '/REL00/REL00016', component: REL00016 },
];
export default REL_ROUTES;
